import { render } from "./HeroiconsOutlineChevronUp.vue?vue&type=template&id=4f88e980"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronUp.vue"]])

export default __exports__